import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  errorsAlert: {
    zIndex: 1,
    position: 'sticky',
    top: 0,
    marginBottom: theme.spacing(3),
    '& > div': {
      margin: 'initial', // Have icon & text left aligned as per design
    },
  },
  stageContainer: {
    padding: theme.spacing(1),
    flex: 1,
    overflowY: 'scroll',
  },
}));
